// What this browser's web push is right now, asked for in one place so the
// Settings section and Today's invitation read the same answer and one
// turning notifications on updates the other.
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from './queries';
import { webPush } from './webPush';

export const WEB_PUSH_STATUS_KEY = ['web-push-status'];

/** This browser's push status. Re-read on every mount: the browser's permission can change outside the page. */
export const useWebPushStatus = () => useQuery({ queryKey: WEB_PUSH_STATUS_KEY, queryFn: () => webPush.status(), staleTime: 0 });

/** Ask for the status again, after something that may have changed it. */
export function useRefreshWebPushStatus() {
  const queryClient = useQueryClient();
  return () =>
    Promise.all([
      queryClient.invalidateQueries({ queryKey: WEB_PUSH_STATUS_KEY }),
      // The account's device count is what Today's warning and the reminder fields read.
      queryClient.invalidateQueries({ queryKey: queryKeys.homeWarnings }),
    ]);
}
